import { render, staticRenderFns } from "./SimpleFullWidthContentWrapper.vue?vue&type=template&id=379103ab&scoped=true&"
import script from "./SimpleFullWidthContentWrapper.vue?vue&type=script&lang=js&"
export * from "./SimpleFullWidthContentWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SimpleFullWidthContentWrapper.vue?vue&type=style&index=0&id=379103ab&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379103ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('379103ab')) {
      api.createRecord('379103ab', component.options)
    } else {
      api.reload('379103ab', component.options)
    }
    module.hot.accept("./SimpleFullWidthContentWrapper.vue?vue&type=template&id=379103ab&scoped=true&", function () {
      api.rerender('379103ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/wrappers/SimpleFullWidthContentWrapper.vue"
export default component.exports